import { eventSenderManager } from 'lib/analytics/eventSender'
import { useEffect } from 'react'
import { useSessionStore } from 'store/session'

import * as amplitude from '@amplitude/analytics-browser'

const amplitudeApiKey = process.env.NEXT_PUBLIC_AMPLITUDE_API_KEY

export function AnalyticsMetadata() {
  const {
    user: { corporate, id: userId }
  } = useSessionStore()

  useEffect(() => {
    if (amplitudeApiKey) {
      amplitude.init(amplitudeApiKey, {
        autocapture: {
          attribution: true,
          sessions: true,
          pageViews: true,
          formInteractions: true
        }
      })
    }
  }, [])

  useEffect(() => {
    if (corporate) {
      const { corporateId, document, name } = corporate.data
      eventSenderManager.updateUserMetadata({
        corporateId,
        corporateDocument: document,
        corporateName: name,
        user_id: userId
      })
    }
  }, [corporate, userId])

  return null
}
